export default "__VITE_ASSET__BQ_Df6jU__"